/**
 * Class description
 *
 * Created: 2019-Sep-20
 *
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class RomanEmpireGameAssets {

    public static NEW_INTRO_BACKGROUND_PLATE = "resources/images/intro/newIntroBackgroundPlate.jpg";
    public static INTRO_BORDER_TILE_TOP = "resources/images/intro/borderTileTop.png";
    public static INTRO_BORDER_TILE_Bottom = "resources/images/intro/borderTileBottom.png";
    public static GENIE_PARADE = "nolimit/screens/images/page_3.png";
    public static GENIE_PARADE_US = "nolimit/screens/images/page_3_US.png";
    public static GENIE_LAMP = "nolimit/screens/images/page_2.png";
    public static GENIW_WISHES = "nolimit/screens/images/page_1.png";
    public static GENIW_WISHES_US = "nolimit/screens/images/page_1_US.png";
    public static CLOUD = "resources/images/intro/Cloud.png";
    public static INTRO_LOGO = "resources/images/intro/introLogo.png";
    public static NOLIMIT_BONUS_ANIMATION = "resources/images/intro/NolimitBonusAnimation.json";
    public static INTRO_BUY_FEATURE_ICON = "resources/images/intro/buyFeatureIcon.svg";
    public static PROMO_FREESPIN = "nolimit/promo-panel/GENIE_RESPIN.png";

    public static INTRO_BACKGROUND_LANDSCAPE: string = "introLogo";
    public static INTRO_BACKGROUND_PORTRAIT: string = "introBackground_Portrait";

    //public static NORMAL_REEL_DIVIDER: string = "reelDivider";
    //public static NEAR_WIN_REEL_DIVIDER: string = "reelDividerNearWin";

    public static MAIN_GAME_BACKGROUND: string = "mainBackground";
    public static BONUS_GAME_BACKGROUND: string = "BonusBackground";

    public static REEL_BACKGROUND: string = "ReelArea/ReelArea";


    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "." + stateName; //as symbol given by graphic team like L2.spin so replaced the _ with .
    }

    public static getSymbolStateTextures(symbolName: string, stateName: string | null = null): PIXI.Texture[] {
        return GameResources.getTextures(RomanEmpireGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],
        main: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset("NumbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt")
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json"),
                    new TextureAsset("main8", "sheets/main/main8.json"),
                     new TextureAsset("main9", "sheets/main/main9.json"),
                     new TextureAsset("main10", "sheets/main/main10.json")
                ],
                animations: {
                    "Betline_1": "Betline/1",
                    "Betline_4": "Betline/4",
                    "Betline_6": "Betline/6",
                    "Betline_8": "Betline/8",
                    "Betline_10": "Betline/10",
                    "Betline_18": "Betline/18",
                    "Betline_20": "Betline/20",
                    "Shadow": "Betline/Shadow",
                    "shine": "Betline/shine",
                    "sparklesWinAnimation": "Sparkle_Win_Animation/Sparkle_Win_Animation_000",

                    "bigWinCoin0": "bigwin/Golden Coin/",
                    "bigWinCoin1": "bigwin/Blue Gem/",
                    "bigWinCoin2": "bigwin/Diamond/gem_blue_",
                    "puffs": "Common_overlay/Common_overlay_",
                    "featureBgRays": "Feature_Animation/Bg_rays/Bg_rays_",
                    "anticipationGlow": "Anticipation/Frame_Glow/Frame_Glow_",
                    "anticipationTrail": "Anticipation/Frame_Trail/Frame_Trail_",
                    "scatterTriggerOverlay": "Scatter/Trigger_overlay/Trigger_overlay_",
                    "scatterRays": "Scatter/Trigger_rays/Scatter_Rays",
                    "genieFeatureRays": "Common_rays/rays_",
                    "landingFrame": "landingAnim/landingFrame",
                    "featureMagicSmokeStart": "Feature_Animation/Magic_smoke/Magic_smoke_start/Magic_smoke_start_",
                    "featureMagicSmokeLoop": "Feature_Animation/Magic_smoke/Magic_smoke_loop/Magic_smoke_loop_",
                    "featureMagicSmokeEnd": "Feature_Animation/Magic_smoke/Magic_smoke_end/Magic_smoke_end_",
                    "lock": "Feature_Animation/Lock/Lock_",
                    //background animation
                    "mainBackgroundWall": "BG_Clouds/mainBackgroundWall",
                    "leftCloud": "BG_Clouds/Cloud_left",
                    "cloud_pink_left": "BG_Clouds/cloud_pink_left",
                    "rightCloud": "BG_Clouds/Cloud_right",
                    "clound_pink_right": "BG_Clouds/clound_pink_right",

                    //Golden genie
                    "genieHandOverFrame": "FreeSpins_animations/Gold_frame/Gold_frame_00",
                    "goldenFrameBlur": "FreeSpins_animations/Gold_frame_blur/Gold_frame_blur_Static",
                    "multiplierRays": "FreeSpins_animations/Rays_loop/Rays_loop_",
                    "fsAnticipation": "FreeSpins_animations/FS_anticipation/FS_anticipation_",
                    "reelFrameGlow": "FreeSpins_animations/Reelf frame_glow",

                    "goldenBlast":"FreeSpins_animations/Golden_blast/Golden Blast_",
                    "commonParticles3":"Common_particles/particles 3/particles_",
                    "movingEnergy":"FreeSpins_animations/Moving_energy/Moving_energy",
                    "patchCircle" :"patch/Multi_patch_circle",
                    "goldenPatch" :"patch/Gold_patch",
                    "youWonText" :"Intro Outro/YOUWON_text",
                    "genieOutro" :"Intro Outro/genieOutro",
                    "mask" : "patch/mask"

                }
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("M1", "spines/M1.json"),
                    new SpineAsset("M2", "spines/M2.json"),
                    new SpineAsset("M4", "spines/M4.json"),
                    new SpineAsset("M3", "spines/M3.json"),
                    new SpineAsset("M5", "spines/M5.json"),
                    new SpineAsset("L1", "spines/L1.json"),
                    new SpineAsset("L2", "spines/L2.json"),
                    new SpineAsset("L3", "spines/L3.json"),
                    new SpineAsset("L4", "spines/L4.json"),
                    new SpineAsset("L5", "spines/L5.json"),
                    new SpineAsset("bigWinLevels", "spines/Bigwinlevels.json"),
                    new SpineAsset("expandingWild", "spines/Expandingwild.json"),
                    new SpineAsset("introOutro", "spines/IntroOutro.json"),
                    new SpineAsset("smokeBlast", "spines/Smoke_blast.json"),
                    new SpineAsset("symbolAnimation", "spines/AnimSym.json"),
                    new SpineAsset("Reelframe_effect", "spines/Reelframe_effect.json"),
                    new SpineAsset("hand_animation", "spines/hand_animation.json"),
                ]
            },
            {
                name: "freespin",
                assets: [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json"),
                ],
                animations: {
                    "FS_Background": "FS.Background",
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json"),
                    new TextureAsset("mainJpeg12", "sheets/mainJpeg/mainJpeg12.json"),
                    new TextureAsset("mainJpeg13", "sheets/mainJpeg/mainJpeg13.json"),
                    new TextureAsset("mainJpeg14", "sheets/mainJpeg/mainJpeg14.json"),
                    new TextureAsset("mainJpeg15", "sheets/mainJpeg/mainJpeg15.json"),
                ],
                animations: {
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                ],
                animations: {
                }
            },
            {
                name: "symbolsAnimation",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolAnimation0", "sheets/symbolAnimation/symbolAnimation0.json"),
                    new TextureAsset("symbolAnimation1", "sheets/symbolAnimation/symbolAnimation1.json"),
                    new TextureAsset("symbolAnimation2", "sheets/symbolAnimation/symbolAnimation2.json"),
                    new TextureAsset("symbolAnimation3", "sheets/symbolAnimation/symbolAnimation3.json"),
                ],
                animations: {
                    "scatterAnticipationIdle": "Scatter_Idle_Anticipation_Trigger/scatter_",
                    "movingScatter": "Scatter_Moving/Scatter_Moving_",
                    "goldenGenie": "Scatter_Golden/Scatter_Golden_",
                    "randomWild": "Random_wild/Random_wild_",
                    "leftLogo": "gameLogo/genie_logo",
                    "rightLogo": "gameLogo/golden_logo",
                }
            }
        ]
    };
}
